import { useState, useEffect, useCallback } from 'react';
import { api } from '../lib/api';

export function useStore() {
  const [people, setPeople] = useState([]);
  const [groups, setGroups] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [settlements, setSettlements] = useState([]);
  const [balances, setBalances] = useState({ net: {}, netTotals: {}, transactions: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      const [p, g, e, s, b] = await Promise.all([
        api.getPeople(), api.getGroups(), api.getExpenses(),
        api.getSettlements(), api.getBalances()
      ]);
      setPeople(p); setGroups(g); setExpenses(e);
      setSettlements(s); setBalances(b);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const addExpense = async (data) => { await api.addExpense(data); await load(); };
  const deleteExpense = async (id) => { await api.deleteExpense(id); await load(); };
  const addGroup = async (data) => { const g = await api.addGroup(data); await load(); return g; };
  const deleteGroup = async (id) => { await api.deleteGroup(id); await load(); };
  const addPerson = async (data) => { const p = await api.addPerson(data); await load(); return p; };
  const addSettlement = async (data) => { await api.addSettlement(data); await load(); };

  return {
    people, groups, expenses, settlements, balances,
    loading, error, reload: load,
    addExpense, deleteExpense, addGroup, deleteGroup, addPerson, addSettlement,
  };
}
